/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessValidationByContext {
    getFixupPrototypeFunction() { return AccessValidationByContext.fixupPrototype; }

    static newInstance(model: Partial<AccessValidationByContext>): AccessValidationByContext {
        let obj = Object.assign(new AccessValidationByContext(), model);
        AccessValidationByContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessValidationByContext>): AccessValidationByContext {
        if (!model) return null;
        return AccessValidationByContext.newInstance(<AccessValidationByContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessValidationByContext) {
        if (!obj) return;

        models.AccessValidationByContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessValidationByContext): boolean {
        Object.setPrototypeOf(obj, AccessValidationByContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.location) {
            models.LocationDetailsBase.fixupPrototype(this.location);
        }
        if (this.resource_group) {
            models.ResourceGroupDetailsBase.fixupPrototype(this.resource_group);
        }
    }

    /**
     * Optional location context for the permission checks
     */
    location: models.LocationDetailsBase;

    /**
     * Optional resource group context for the permission checks
     */
    resource_group: models.ResourceGroupDetailsBase;

    /**
     * Permissions Allowed
     */
    access_granted: Array<string>;

    /**
     * Permissions Denied
     */
    access_denied: Array<string>;

}
